import jQuery from 'jquery'
import 'jquery-validation';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

import CustomAnimation from "src/scripts/animation/customAnimation";
import {gsap} from "gsap";
import {S3Client, PutObjectCommand} from '@aws-sdk/client-s3';

const customAnmation = new CustomAnimation();

// Configure AWS SDK
const s3Client = new S3Client({
  region: 'eu-central-1',
  credentials: {
    accessKeyId: 'AKIAW6SPG472JMTM7XX4',
    secretAccessKey: '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',
  }
});

class Qualification {
  constructor() {
    this.s3Client = s3Client;
  }

  init() {
    this.initPage();
    this.initParallax();
    this.initForm();

  }

  initPage = () => {

    // teilnehmer 2 validation check
    let participant2List = [];
    participant2List.push('#firstname_participant_2');
    participant2List.push('#lastname_participant_2');
    participant2List.push('#birth_participant_2');
    participant2List.push('#consentform_2');

    jQuery.each(participant2List, function (index, value) {
      // alert( index + ": " + value );

      jQuery(value).change(function () {

        //console.log( $("input[name='eu_citizens_participant_2']:checked").val()  );

        // if firstname or lastname or birth of teilnehmer is selected
        if (jQuery(participant2List[0]).val() != '' || jQuery(participant2List[1]).val() != '' || jQuery(participant2List[2]).val() != '') {
          jQuery.each(participant2List, function () {
            jQuery(this).attr("placeholder", jQuery(this).data('placeholder') + " *");
            jQuery(this).rules("add", {
              required: true
            });
          })
        } else {
          jQuery.each(participant2List, function () {
            jQuery(this).attr("placeholder", jQuery(this).data('placeholder'));
            jQuery(this).rules("remove");
          })
        }

        $("#registration").valid();
      })
    });
  }

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);

    customAnmation.animateHeaderImage('.header');
  }

  initForm = () => {
    this.resetForm();

    function generateRandomCharacters() {
      const array = new Uint8Array(16);
      window.crypto.getRandomValues(array);
      return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
    }

    document.getElementById('proofofpurchase').addEventListener('change', async function (event) {
      const fileInput = event.target;
      const label = document.querySelector('label[for="proofofpurchase"]');
      if (fileInput.files.length > 0) {
        fileInput.setAttribute('uploading', 'true');
        if (fileInput.files[0].size > 10 * 1024 * 1024) {
          label.textContent = 'Datei zu groß (max. 10MB)';
          fileInput.value = "";
          fileInput.removeAttribute('uploading');
          return;
        }
        label.textContent = 'Uploading...';
        try {
          const params = {
            Bucket: 'tp-vision-aktion-scratch',
            Key: generateRandomCharacters() + '/' + fileInput.files[0].name,
            Body: fileInput.files[0],
            ContentLength: fileInput.files[0].size,
            ContentType: fileInput.files[0].type
          };
          const command = new PutObjectCommand(params);
          const upload = that.s3Client.send(command);
          await upload;
          label.textContent = `${fileInput.files[0].name} erfolgreich hochgeladen`;
          fileInput.removeAttribute('uploading');
          fileInput.setAttribute('key', params.Key);
        } catch (err) {
          label.textContent = 'Upload fehlgeschlagen: ' + err;
          fileInput.value = "";
          fileInput.removeAttribute('uploading');
        }

      } else {
        label.textContent = 'Upload Kaufbeleg Ambilight TV';
      }
    });
    document.getElementById('consentform').addEventListener('change', async function (event) {
      const fileInput = event.target;
      const label = document.querySelector('label[for="consentform"]');
      if (fileInput.files.length > 0) {
        fileInput.setAttribute('uploading', 'true');
        if (fileInput.files[0].size > 10 * 1024 * 1024) {
          label.textContent = 'Datei zu groß (max. 10MB)';
          fileInput.value = "";
          fileInput.removeAttribute('uploading');
          return;
        }
        label.textContent = 'Uploading...';
        try {
          const params = {
            Bucket: 'tp-vision-aktion-scratch',
            Key: generateRandomCharacters() + '/' + fileInput.files[0].name,
            Body: fileInput.files[0],
            ContentLength: fileInput.files[0].size,
            ContentType: fileInput.files[0].type
          };
          const command = new PutObjectCommand(params);
          const upload = that.s3Client.send(command);
          await upload;
          label.textContent = `${fileInput.files[0].name} erfolgreich hochgeladen`;
          fileInput.removeAttribute('uploading');
          fileInput.setAttribute('key', params.Key);
        } catch (err) {
          label.textContent = 'Upload fehlgeschlagen: ' + err;
          fileInput.value = "";
          fileInput.removeAttribute('uploading');
        }

      } else {
        label.textContent = 'Upload Einverständniserklärung Kind 1';
      }
    });
    document.getElementById('consentform_2').addEventListener('change', async function (event) {
      const fileInput = event.target;
      const label = document.querySelector('label[for="consentform_2"]');
      if (fileInput.files.length > 0) {
        fileInput.setAttribute('uploading', 'true');
        if (fileInput.files[0].size > 10 * 1024 * 1024) {
          label.textContent = 'Datei zu groß (max. 10MB)';
          fileInput.value = "";
          fileInput.removeAttribute('uploading');
          return;
        }
        label.textContent = 'Uploading...';
        try {
          const params = {
            Bucket: 'tp-vision-aktion-scratch',
            Key: generateRandomCharacters() + '/' + fileInput.files[0].name,
            Body: fileInput.files[0],
            ContentLength: fileInput.files[0].size,
            ContentType: fileInput.files[0].type
          };
          const command = new PutObjectCommand(params);
          const upload = that.s3Client.send(command);
          await upload;
          label.textContent = `${fileInput.files[0].name} erfolgreich hochgeladen`;
          fileInput.removeAttribute('uploading');
          fileInput.setAttribute('key', params.Key);
        } catch (err) {
          label.textContent = 'Upload fehlgeschlagen: ' + err;
          fileInput.value = "";
          fileInput.removeAttribute('uploading');
        }

      } else {
        label.textContent = 'Upload Einverständniserklärung Kind 2';
      }
    });
    const that = this;
    const formMessages = jQuery('#form-messages');

    jQuery("#registration").validate({

      rules: {
        proofofpurchase: 'required',
        firstname: 'required',
        lastname: 'required',
        email: {
          required: true,
          email: true
        },
        email_repeat: {
          required: true,
          email: true,
          equalTo: '#email'
        },
        street: 'required',
        street_number: 'required',
        postcode: 'required',
        city: 'required',
        phone: 'required',
        country: {
          required: true
        },
        consentform: 'required',
        firstname_participant_1: 'required',
        lastname_participant_1: 'required',
        birth_participant_1: 'required',
        participation: 'required',
        nomination: 'required'
      },
      messages: {
        proofofpurchase: 'Bitte wähle Deinen Kaufbeleg aus.',
        firstname: 'Bitte gebe Deinen Vornamen ein.',
        lastname: 'Bitte gebe Deinen Nachnamen ein.',
        email: 'Bitte gebe Deine korrekte E-Mail ein.',
        email_repeat: 'Bitte gebe Deine korrekte E-Mail erneut ein.',
        street: 'Bitte gebe Deine Strasse ein.',
        street_number: 'Bitte gebe Deine Hausnummer ein.',
        postcode: 'Bitte gebe Deine Postleitzahl ein.',
        city: 'Bitte gebe Deinen Ort ein.',
        phone: 'Bitte gebe Deine Telefonnummer ein.',
        country: 'Bitte gebe Dein Land ein.',
        consentform: 'Bitte wähle Deine Einverständnis-Erklärung aus.',
        consentform_2: 'Bitte wähle Deine Einverständnis-Erklärung aus.',
        firstname_participant_1: 'Bitte gebe den Vornamen des 1. Teilnehmers ein.',
        lastname_participant_1: 'Bitte gebe den Nachnamen des 1. Teilnehmers ein.',
        birth_participant_1: 'Bitte gebe das Geburtsdatum des 1. Teilnehmers ein.',
        firstname_participant_2: 'Bitte gebe den Vornamen des 2. Teilnehmers ein.',
        lastname_participant_2: 'Bitte gebe Nachnamen des 2. Teilnehmers ein.',
        birth_participant_2: 'Bitte gebe das Geburtsdatum des 2. Teilnehmers ein.',
        participation: 'Bitte akzeptiere die Teilnahmebedingungen und Datenschutzbestimmungen.',
        analysis: 'Bitte akzeptiere die Bedingungen.',
        nomination: 'Hast Du die Nominierten in Kenntnis gesetzt?'
      },
      submitHandler(form) {
        const formData = jQuery(form).serializeArray().reduce((obj, item) => {
          obj[item.name] = item.value;
          return obj;
        }, {});

        if (jQuery('#proofofpurchase')[0].hasAttribute('uploading')) {
          formMessages.text('Bitte warten Sie, bis der Kaufbeleg hochgeladen wurde.');
          return
        } else if (jQuery('#proofofpurchase')[0].hasAttribute('key')) {
          formData['proofofpurchase'] = jQuery('#proofofpurchase').attr('key');
        }

        if (jQuery('#consentform')[0].hasAttribute('uploading')) {
          formMessages.text('Bitte warten Sie, bis die Einverständniserklärung (1) hochgeladen wurde.');
          return
        } else if (jQuery('#consentform')[0].hasAttribute('key')) {
          formData['consentform'] = jQuery('#consentform').attr('key');
        }
        if (jQuery('#consentform_2')[0].hasAttribute('uploading')) {
          formMessages.text('Bitte warten Sie, bis die Einverständniserklärung (2) hochgeladen wurde.');
          return
        } else if (jQuery('#consentform_2')[0].hasAttribute('key')) {
          formData['consentform_2'] = jQuery('#consentform_2').attr('key');
        }

        that.submitForm(formData, formMessages);
      }
    });
  }

  submitForm(formData, formMessages) {
    jQuery('.button_form_send').addClass('button_loading');
    jQuery.ajax({
      type: 'POST',
      url: 'https://6pcbpgccnuofck2kzf6gk6wzw40xsard.lambda-url.eu-central-1.on.aws/',
      data: JSON.stringify(formData),
      contentType: 'application/json',
      dataType: 'json',
      processData: false,
    })
      .done(function (response) {
        if(response){ // check whether response is received
          window.location.href = "thankyou.html";
      }
        formMessages.text(response.message);
      })
      .fail(function (data) {
        formMessages.text(data.message || 'Oops! An error occurred and your message could not be sent.');
      });
  }

  resetForm_dummy() {
    jQuery('#proofofpurchase').val('');
    jQuery('#firstname').val('Sebastian');
    jQuery('#lastname').val('Annies');
    jQuery('#email').val('Sebastian.Annies@gmail.com');
    jQuery('#email_repeat').val('Sebastian.Annies@gmail.com');
    jQuery('#street').val('Bei der Apostelkriche');
    jQuery('#street_number').val('12');
    jQuery('#postcode').val('20257');
    jQuery('#city').val('Hamburg');
    jQuery('#phone').val('0123 456789');
    jQuery('#country').val('deutschland');
    jQuery('#consent_form').val('');
    jQuery('#consent_form_2').val('');
    jQuery('#firstname_participant_1').val('Max');
    jQuery('#lastname_participant_1').val('Annies');
    jQuery('#birth_participant_1').val('2017-02-26');
    jQuery('#firstname_participant_2').val('');
    jQuery('#lastname_participant_2').val('');
    jQuery('#birth_participant_2').val('');
    jQuery('#participation').prop('checked', true);
    jQuery('#analysis').prop('checked', true);
    jQuery('#nomination').prop('checked', true);
  }

  resetForm() {
    jQuery('#proofofpurchase').val('');
    jQuery('#firstname').val('');
    jQuery('#lastname').val('');
    jQuery('#email').val('');
    jQuery('#email_repeat').val('');
    jQuery('#street').val('');
    jQuery('#street_number').val('');
    jQuery('#postcode').val('');
    jQuery('#city').val('');
    jQuery('#phone').val('');
    jQuery('#country').val('');
    jQuery('#consent_form').val('');
    jQuery('#consent_form_2').val('');
    jQuery('#firstname_participant_1').val('');
    jQuery('#lastname_participant_1').val('');
    jQuery('#birth_participant_1').val('');
    jQuery('#firstname_participant_2').val('');
    jQuery('#lastname_participant_2').val('');
    jQuery('#birth_participant_2').val('');
    jQuery('#participation').prop('checked', false);
    jQuery('#analysis').prop('checked', false);
    jQuery('#nomination').prop('checked', false);
  }
}

export default Qualification;
